import { BinButton } from './BinButton';
import { SaveCancelButtons } from './SaveCancelButtons';
import { VersionSelectorRight } from './VersionSelectorRight';
import { EditionButton } from './EditionButton';


export const ActionsPanel = ({
    selectedVersion,
    viewportMode,
    onEditMode,
    passive,
    hasChanges,
    handleSaveAndExit,
    dispatch,
    setOnEditMode,
    deniedServices,
    versions,
    currentValue,
    handleVersionChange,
    handleEnterEdition,
    logoUrl,
}) => (
    <>
        <BinButton selectedVersion={selectedVersion} viewportMode={viewportMode} onEditMode={onEditMode} dispatch={dispatch} setOnEditMode={setOnEditMode} />
        <SaveCancelButtons onEditMode={onEditMode} passive={passive} hasChanges={hasChanges} handleSaveAndExit={handleSaveAndExit} dispatch={dispatch} setOnEditMode={setOnEditMode} />
        <VersionSelectorRight passive={passive} viewportMode={viewportMode} deniedServices={deniedServices} versions={versions} currentValue={currentValue} onEditMode={onEditMode} handleVersionChange={handleVersionChange} />
        <EditionButton passive={passive} deniedServices={deniedServices} viewportMode={viewportMode} onEditMode={onEditMode} handleEnterEdition={handleEnterEdition} />
    </>
);
